module.exports = __webpack_public_path__ + "static/media/instances2-inactive.068004f4.svg";